import { Spin } from "antd";
import React, { Component } from "react";
import moment from 'moment';
import { SyncOutlined } from '@ant-design/icons';
import postService from "../../services/httpService";
import networkList from "../../constants/networkList";

const {getDashboardCountForWorklists, } = networkList;
class WorklistDashboard extends Component {
    constructor(props){
        super();
        this.state = {
            loading: false,
            lastRefeshTime: moment(),
            data: null,
            cardsDetails: [
                { key: "track_bills",type: "trackbill",name: "Track Bills", total_count: 0, bgColor: "bg3", url: "/worklist/track-bills?type=trackbill",},
                { key: "due", type: "duebill",name: "Due Worklist", total_count: 0, bgColor: "bg1", url: "/worklist/track-bills?type=duebill",},
                { key: "consent_patients", name: "Consent Patients", total_count: 0, bgColor: "bg7", url: "/worklist/consent-patients",},
                { key: "planned_estimates", name: "Planned Admissions", total_count: 0, bgColor: "bg2", url: "/worklist/planned-admissions",},
                { key: "planned_without_estimates", name: "Without Estimate", total_count: 0, bgColor: "bg4", url: "/worklist/track-bills",},
                { key: "sugeries", name: "Surgeries Worklist", total_count: 0, bgColor: "bg5", url: "/worklist/surgeries-worklist",},
                { key: "insurance_conversion_pending",type:"icpending", name: "Insurance Conversion Pending", total_count: 0, bgColor: "bg6",url: "/worklist/track-bills?type=icpending"},
                { key: "insurance_rejected_cnt",type:"case4", name: "Insurance Reject", total_count: 0, bgColor: "bg8",url: "/worklist/track-bills?type=case4"},
                { key: "org_mismatch_cnt",type: "case10",name: "Organization MisMatch", total_count: 0, bgColor: "bg3", url: "/worklist/track-bills?type=case10",},
            ],
        }
    }

    componentDidMount() {
         this.setState({loading: true})
        this.fetchDetails();
        this.refresh_interval = setInterval(() => {
            this.refeshpage();
        }, 60000)
    }

    componentWillUnmount() {
        clearInterval(this.refresh_interval);
    }

    refeshpage = () => {
        this.fetchDetails()
    }

    fetchDetails = () => {
        let {cardsDetails, } = this.state;
        // this.setState({loading: true})
        postService(getDashboardCountForWorklists, "GET", null).then(res => {
            if(res.status){
                if(res.data.length){
                    let data = res.data[0];
                    cardsDetails.map((card, card_key) => {
                        if(data[card["key"]]){
                            cardsDetails[card_key]["total_count"] = data[card["key"]]
                        }
                    })
                }
                this.setState({loading: false, data: res.data, cardsDetails: cardsDetails, lastRefeshTime: moment(), })
            }
        })
    }
    
    onclick = (url, key,type) => {
        console.log("Type" ,type);
        localStorage.setItem("billtype" ,type )
        if(key === "planned_without_estimates"){
            localStorage.setItem("planned_without_estimates", JSON.stringify(true));
        }
        this.props.history.push(url);
    }

    render(){
        const {loading, lastRefeshTime, cardsDetails, } = this.state;
     
        return (
            <div className="mt-3 mx-4 mb-5"> 
                <Spin spinning={loading}>
                    <div className="row">
                        {/* <div className="col-xl-2 col-lg-2">
                        </div> */}
                        <div className="col-xl-12 col-lg-12">
                            <p className='text-right dashboard'>Last Refreshed at : {moment(lastRefeshTime).format('hh:mm A')} <SyncOutlined className='ml-2' onClick={this.refeshpage.bind()}/> </p>
                        </div>
                    </div>

                    <div className="man-dash row">
                        {cardsDetails && cardsDetails.map((card, card_key) => {
                            return (
                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 mb-5" id={card_key}>
                                    <div className={`card border border-0 ${card.bgColor} h-100`} onClick={() => this.onclick(card.url, card.key, card.type)} style={{cursor: "pointer"}}>
                                        <div className='col p-0 mt-3'>
                                            <h1>{card['total_count'] ? card['total_count'] : 0}</h1>
                                        </div>
                                        <div className='col p-0 mb-2'>
                                            {/* <h2>{card["name1"]}</h2>
                                            <h2>{card["name2"]}</h2> */}
                                            <h2>{card["name"]}</h2>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </Spin>
            </div>
        )
    }
}
export default WorklistDashboard;